import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  ExtendedBaseInterface,
  RentalListing,
  RentalListingsRequest,
  RentalSearchRequest,
  RentalMapMarkerItem,
} from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class RentalService {
  constructor(private http: HttpClient) {}

  getFeaturedRentals(): Observable<RentalListing[]> {
    const payload: RentalSearchRequest = {
      pageNumber: 1,
      pageSize: 24,
      sortColumn: '',
      sortOrder: '',
      search: '',
      isSplit: false,
    };

    return this.searchProperties(payload).pipe(
      map((response) =>
        Array.isArray(response?.result)
          ? (response.result as RentalListing[])
          : [],
      ),
    );
  }

  createOrUpdateListing(
    data: RentalListing,
  ): Observable<ExtendedBaseInterface> {
    return this.http.post<ExtendedBaseInterface>(
      `${environment.baseUrl}Rental/CreateOrUpdateListing`,
      data,
    );
  }

  getListings(data: RentalListingsRequest): Observable<ExtendedBaseInterface> {
    return this.http.post<ExtendedBaseInterface>(
      `${environment.baseUrl}Rental/GetListings`,
      data,
    );
  }

  getListingById(id: number): Observable<ExtendedBaseInterface> {
    return this.http.get<ExtendedBaseInterface>(
      `${environment.baseUrl}Rental/Listing/${id}`,
    );
  }

  getPublicListingById(id: number): Observable<ExtendedBaseInterface> {
    return this.http.get<ExtendedBaseInterface>(
      `${environment.baseUrl}Rental/Public/Listing/${id}`,
    );
  }

  submitForApproval(id: number): Observable<ExtendedBaseInterface> {
    return this.http.post<ExtendedBaseInterface>(
      `${environment.baseUrl}Rental/SubmitForApproval/${id}`,
      null,
    );
  }

  deleteListing(id: number): Observable<ExtendedBaseInterface> {
    return this.http.delete<ExtendedBaseInterface>(
      `${environment.baseUrl}Rental/DeleteListing/${id}`,
    );
  }

  uploadImage(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('File', file);

    return this.http.post(
      `${environment.baseUrl}Rental/UploadImage`,
      formData,
      {
        responseType: 'text',
      },
    );
  }

  searchProperties(
    data: RentalSearchRequest,
  ): Observable<ExtendedBaseInterface> {
    return this.http.post<ExtendedBaseInterface>(
      `${environment.baseUrl}Rental/SearchProperty`,
      data,
    );
  }

  getRentalMapMarkers(
    data: RentalSearchRequest,
  ): Observable<RentalMapMarkerItem[]> {
    return this.http.post<RentalMapMarkerItem[]>(
      `${environment.baseUrl}Rental/map-markers`,
      data,
    );
  }
}
